/** User delegation target kind */
export enum UserDelegationTargetKindEnum {
  /** Delegate active BRS tasks */
  ACTIVE_BRS_TASKS = 'ACTIVE_BRS_TASKS',
}
